module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("AWM Jr.")])]), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Arthur W. Machan Jr. (Arly) (brother)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("AWM Sr.")])]), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Arthur Webster Machen (father)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("JGM")])]), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("J. Gresham Machen")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("MGM")])]), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Mary Gresham Machen (mother)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("TGM")])]), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("Tom Gresham Machen (brother)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "abbr1"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("WPA")])]), _c('td', {
    staticClass: "abbr2"
  }, [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("William Park Armstrong")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf6f51d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Abbreviations.vue
// module id = 78
// module chunks = 0